import { Box, FormControl, FormHelperText, TextField } from "@mui/material";
import VerificationLayout from "../../../../layout/VerificationLayout.component";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import { AddCircleOutline, CheckCircle } from "@mui/icons-material";
import Theme from "../../../../../utils/Theme";
import { useState } from "react";
import AppButton from "../../../../base/AppButton.component";
import { InputValidation } from "../../../../../utils/InputValidationRegex";
import { useMutation, useQuery } from "@apollo/client";
import { SUBMIT_REFERRAL } from "../../../../../graphql/mutation/mutation";
import { useParams } from "react-router-dom";
import { FETCH_REFERRAL_DETAILS } from "../../../../../graphql/query/query";
import ContentShimmer from "react-content-shimmer";

const SubmitReferrals = () => {
  const params = useParams();
  const [refUsers, setRefUsers] = useState([{ name: "", mobile_number: "" }]);
  const [success, setSuccess] = useState(false);
  const { data } = useQuery(FETCH_REFERRAL_DETAILS, {
    variables: {
      userId: parseInt(params?.userId),
    },
  });
  const [submitReferral, { loading: updateLoading }] =
    useMutation(SUBMIT_REFERRAL);

  const handleTextChange = (index, field, value) => {
    setRefUsers((prev, i) =>
      prev.map((data, i) => (index === i ? { ...data, [field]: value } : data))
    );
  };
  const handleUser = () => {
    setRefUsers((prev) => [...prev, { name: "", mobile_number: "" }]);
  };

  console.log("REFUSERS", refUsers, params);

const checkError = () => {
  return refUsers.some((data) => {

    if (data?.name === "" && data?.mobile_number === "") {
      return false; 
    }
    
    // Validate name if it has content
    const hasNameError = data?.name !== "" && InputValidation.nameValidation(data?.name);
    
    const hasMobileError = data?.mobile_number !== "" && 
                          InputValidation.numberValidation(data?.mobile_number);
    
    return hasNameError || hasMobileError;
  });
};

  const submitHandler = () => {
    submitReferral({
      variables: {
        referralInput: {
          user_id: parseInt(params.userId),
          refUsers: refUsers,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          dealership_id: parseInt(params?.dealershipId),
          employee_user_id: parseInt(params?.employeeId),
        },
      },
    }).then((data) => {
      if (data?.data?.submitReferralLink?.status) {
        console.log("DATA", data);
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          setRefUsers([{ name: "", mobile_number: "" }]);
        }, 3000);
      }
    });
  };
  console.log("Sucess", success);

  return (
    <VerificationLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          width: "100%",
          gap: "10px",
          p: 3,
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "8px",
            justifyContent: "center",
            alignItems: "center",
            height: "40%",
          }}
        >
          {data?.fetchReferralDetails ? (
            <>
              <img
                src={data?.fetchReferralDetails.dealership_logo}
                width={150}
                height={60}
              />
              <pre style={ArtifactStyle.textBox}>
                {data?.fetchReferralDetails.message}
              </pre>
            </>
          ) : (
            <Box>
              <ContentShimmer />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            height: "50%",
            justifyContent: "flex-start",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "90%",
              height: "100%",
              maxHeight: "500px",
              overflowY: "auto",
              p: 2,
            }}
          >
            {refUsers.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: window.innerWidth <= 750 ? "column" : "row",
                  gap: "12px",
                }}
              >
                <FormControl variant="outlined" fullWidth>
                  <TextField
                    label="Name"
                    value={item.name}
                    onChange={(e) =>
                      handleTextChange(index, "name", e.target.value)
                    }
                    error={InputValidation.nameValidation(item.name)}
                  />
                  <FormHelperText sx={{ color: Theme.palette.error.main }}>
                    {InputValidation.nameValidation(item.name)
                      ? "Please enter a valid name"
                      : " "}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="outlined" fullWidth>
                  <TextField
                    label="Mobile Number"
                    value={InputValidation.phoneNumberFormat(
                      item.mobile_number || ""
                    )}
                    onChange={(e) =>
                      handleTextChange(index, "mobile_number", e.target.value)
                    }
                    error={InputValidation.numberValidation(
                      item.mobile_number || ""
                    )}
                  />
                  <FormHelperText sx={{ color: Theme.palette.error.main }}>
                    {InputValidation.numberValidation(item.mobile_number)
                      ? "Please enter a valid contact"
                      : " "}
                  </FormHelperText>
                </FormControl>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              height: "100%",
              width: "10%",
              pt: "32px",
            }}
          >
            <AddCircleOutline
              sx={{
                fontSize: "20px",
                color: Theme.palette.primary.main,
                cursor: "pointer",
              }}
              onClick={handleUser}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "10%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {success ? (
            <Box sx={{ display: "flex", my: "14px" }}>
              <CheckCircle color={"primary"} />
              <span
                style={{
                  color: Theme.palette.primary.main,
                  marginLeft: "4px",
                }}
              >
                SUCCESS
              </span>
            </Box>
          ) : (
            <AppButton
              buttonText={"Submit"}
              disabled={checkError()}
              clickHandler={submitHandler}
              sx={{
                width: "80%",
                alignSelf: "center",
              }}
              loading={updateLoading}
            />
          )}
        </Box>
      </Box>
    </VerificationLayout>
  );
};

export default SubmitReferrals;